import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.values.js";
export var getScreenFromWidth = function getScreenFromWidth(width, screens) {
  var screenName = 'miniPhone';
  var names = Object.keys(screens);
  var widths = Object.values(screens);
  for (var i = 0; i < names.length; i++) {
    if (widths[i] <= width) {
      screenName = names[i];
    }
  }
  return screenName;
};